import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SalaryOneResponseDto, SalaryOneUpsertRequest } from '../../models/api/companySalaryOneDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanySalaryOneService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getSalaryOne(companyId: string, year?: number): Observable<YearlyResource<SalaryOneResponseDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<SalaryOneResponseDto>>(
      `${this.apiUrl}/${companyId}/salary-one`,
      { params }
    );
  }

  updateSalaryOne(companyId: string, request: SalaryOneUpsertRequest): Observable<YearlyResource<SalaryOneResponseDto>> {
    return this.http.put<YearlyResource<SalaryOneResponseDto>>(`${this.apiUrl}/${companyId}/salary-one`, request);
  }
}
